import { Alert, Text } from "@/atoms"
import { DisconnectOutlined } from "@/icons"
import {
  ConfigItem,
  FooterConfigItem
} from "@/pages/IntegrationsPage/components/molecules/ConfigItem"
import { FormGcr } from "@/pages/IntegrationsPage/components/molecules/FormGcr"
import { useGcrAPI } from "@/pages/IntegrationsPage/hooks/useGcrAPI"
import { useIntegration } from "@/pages/IntegrationsPage/hooks/useIntegration"
import { INTEGRATIONS_WRITE_PERMISSION } from "@/pages/IntegrationsPage/IntegrationsPage.constants"

import styles from "./GcrConfigurationPage.module.scss"

import type { GcrConfigurationItemProps } from "."

export const GcrConfigurationItem = (props: GcrConfigurationItemProps) => {
  const { registry, tenantServiceAccount, vendor } = props
  const [_, { onRemove, ...actions }] = useIntegration({ vendor })
  const { t } = actions
  const gcrApi = useGcrAPI({ registry, ...actions })
  const { registryUrl, location, repositories, health, legacy } = registry
  const showHealth = !!health && health.status !== "healthy"

  return (
    <ConfigItem
      values={{ id: registryUrl, name: registryUrl, health }}
      Description={
        <Text type="secondary">
          {[
            location,
            t("integrations.gcr.baseImagesCount", {
              count: repositories.length
            }),
            legacy ? t("integrations.gcr.legacyTag") : null
          ]
            .filter(Boolean)
            .join(" · ")}
        </Text>
      }
    >
      <div className={styles.body}>
        {showHealth && health.message && (
          <Alert
            showIcon
            type={health.status === "unhealthy" ? "error" : "warning"}
            title={health.message}
          />
        )}
        {legacy && (
          <Alert
            showIcon
            type="info"
            title={t("integrations.gcr.kodemManaged", {
              email:
                tenantServiceAccount || t("integrations.gcr.yourServiceAccount")
            })}
          />
        )}
        <FormGcr
          formId={gcrApi.formId}
          registry={registry}
          onFinish={gcrApi.onFinish}
          {...actions}
        />
      </div>
      <FooterConfigItem
        formId={gcrApi.formId}
        isDirty={actions.isDirty || !!legacy}
        isPending={gcrApi.isPending || actions.isPending}
        permissions={INTEGRATIONS_WRITE_PERMISSION}
        removeTKey="general.disconnect"
        RemoveIcon={DisconnectOutlined}
        onRemove={() => onRemove({ id: registryUrl, name: registryUrl })}
        onReset={actions.onReset}
      />
    </ConfigItem>
  )
}
